import React, { useCallback, useRef } from 'react';
import { ConfirmDialog, ConfirmDialogAPI, ConfirmDialogOptions } from 'common/ConfirmDialog/ConfirmDialog';

type BaseTypes = string | Record<string, any> | void;

export const ConfirmDialogContext = React.createContext(
  <DATA extends BaseTypes = void>(options?: ConfirmDialogOptions<DATA>) =>
    Promise.resolve(options) as unknown as Promise<DATA | undefined>
);

export const ConfirmDialogProvider = ({ children }: { children: React.ReactNode }) => {
  const confirmDialogRef = useRef<ConfirmDialogAPI<any>>(null);

  const handleConfirm = useCallback(
    async <DATA extends BaseTypes = void>(options?: ConfirmDialogOptions<DATA>) =>
      confirmDialogRef.current?.open(options) as ReturnType<ConfirmDialogAPI<DATA>['open']>,
    []
  );
  return (
    <ConfirmDialogContext.Provider value={handleConfirm}>
      {children}
      <ConfirmDialog ref={confirmDialogRef} />
    </ConfirmDialogContext.Provider>
  );
};
